module.exports = __webpack_public_path__ + "static/media/logo.996cf5e0.png";